import { createBrowserRouter } from "react-router-dom";
import ErrorPage from "../error";
import MarketingPage from "../pages/landingPage/MarketingPage";
import SignIn from "../pages/signIn/signIn";
import SignUp from "../pages/sign-up/signUp";
import Blog from "../pages/blog/BlogPage";
import BlogPost from "../pages/blog/BlogPost";
import Dashboard from "../pages/dashboard/Dashboard";
import IsLoggedIn from "../components/auth/IsLoggedIn";
import CreateBlog from "../pages/blog/CreateBlog";
import AdminBlogPage from "../pages/blog/admin/index";

import DashboardLayout from "../layouts/DashboardLayout";
import AdminUserPage from "../pages/users/admin";
import UserProfile from "../components/users/UserProfile";
import TicketLayout from "../components/tickets";
import TicketsPage from "../pages/tickets";
import Success from "../pages/Success/Success";
import ResetPassword from "../pages/resetPassword/ResetPassword";
import Disputes from "../pages/disputes/Disputes";
import SuccessCreatedUserFirst from "../pages/SuccessCreatedUserFirst/SuccessCreatedUserFirst";
import GymUsersAdminPage from "../pages/gymUsers/GymUsersAdminPage";
import EmployeeProfile from "../components/users/EmployeeProfile";
import SettingsPage from "../pages/settings/settings";
import InventoryPage from "../pages/crm/InventoryPage";
import ClassesPage from "../pages/crm/ClassesPage";
import AssetsPage from "../pages/crm/AssetsPage";
import CatalogPage from "../pages/crm/CatalogPage";
import SalesPage from "../pages/crm/SalesPage";
import AccessPage from "../pages/crm/AccessPage";
import ContractsPage from "../pages/crm/ContractsPage";
import TrainingPage from "../pages/crm/TrainingPage";
import AgendaAdminPage from "../pages/agenda/AgendaAdminPage";
import AgendaSettingsPage from "../pages/agenda/AgendaSettingsPage";
import MyAgendaPage from "../pages/agenda/MyAgendaPage";
import UserAgendaPage from "../pages/agenda/UserAgendaPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <TicketLayout>
        <MarketingPage />
      </TicketLayout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "sign-in",
    element: <SignIn />,
    errorElement: <ErrorPage />,
  },
  {
    path: "sign-up",
    element: <SignUp />,
    errorElement: <ErrorPage />,
  },
  {
    path: "blog",
    element: <Blog />,
    errorElement: <ErrorPage />,
  },
  {
    path: "success",
    element: <Success />,
    errorElement: <ErrorPage />,
  },
  {
    path: "purchase-success",
    element: <SuccessCreatedUserFirst />,
    errorElement: <ErrorPage />,
  },
  {
    path: "blog/:id", // Dynamic route for blog post by ID
    element: <BlogPost />,
    errorElement: <ErrorPage />,
  },
  // CUSTOMER ROUTES
  {
    path: "/customer/dashboard",
    element: (
      <IsLoggedIn>
        <Dashboard props={{ adminLevel: false }} />
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/customer/agenda",
    element: (
      <IsLoggedIn>
        <DashboardLayout>
          <MyAgendaPage />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  // ADMIN LEVEL ROUTES
  {
    path: "dashboard",
    element: (
      <IsLoggedIn adminLevel={true}>
        <Dashboard />
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/blog",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <AdminBlogPage />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/blog/create-blog-article",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <CreateBlog />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/blog/:id",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <CreateBlog />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/users",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <AdminUserPage />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/gym-users",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <GymUsersAdminPage />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/users/create-employee",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <EmployeeProfile />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/users/employee/:id",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <EmployeeProfile />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/users/employee/:id/agenda",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <UserAgendaPage />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/users/gym-user/create-user",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <UserProfile />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/users/gym-user/:id/agenda",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <UserAgendaPage />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/users/gym-user/:id",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <UserProfile />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/tickets/",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <TicketsPage />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/disputes/",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <Disputes />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/settings/",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <SettingsPage />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/inventory/",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <InventoryPage />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/classes/",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <ClassesPage />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/assets/",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <AssetsPage />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/catalog/",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <CatalogPage />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/sales/",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <SalesPage />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/access/",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <AccessPage />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/agenda/",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <AgendaAdminPage />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/agenda/settings",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <AgendaSettingsPage />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/contracts/",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <ContractsPage />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/training/",
    element: (
      <IsLoggedIn adminLevel={true}>
        <DashboardLayout>
          <TrainingPage />
        </DashboardLayout>
      </IsLoggedIn>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "reset-password",
    element: <ResetPassword />,
    errorElement: <ErrorPage />,
  },
]);

export default router;
